import React from 'react';

import { Route, Switch } from "react-router-dom";
import ErrorBoundary from "modules/platform-components/error-boundary/ErrorBoundary";

export const RouteWithSubRoutes = (route) => {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => (
        <>
          {route.component && (
            // Keyed by pathname so navigating to another route remounts the
            // boundary and clears any prior error. Isolates a page-level render
            // crash to that page instead of blanking the whole app.
            <ErrorBoundary key={props.location && props.location.pathname}>
              <route.component {...props} routes={route.routes} />
            </ErrorBoundary>
          )}
          {route.routes && route.routes.length > 0 && (
            <Switch>
              {/*the duplicate component created in sidebar becasue of this */}
              {/* {route.routes.map((subroute) => (
                <RouteWithSubRoutes key={subroute.path} {...subroute} />
              ))} */}
            </Switch>
          )}
        </>
      )}
    />
  );
};
